"use strict"
exports.__esModule = true
exports.newStore = void 0
//@ts-check
var react_1 = require("react")
function cloneDeep(obj) {
  var x=new Date().valueOf()
  // console.log('clone deep')
  // var res= JSON.parse(JSON.stringify(obj))
  // console.log('a',new Date().valueOf()-x)
  var x=new Date().valueOf()
  var res= require('lodash').cloneDeep(obj)
  // console.log('b',new Date().valueOf()-x)
  return res
}
function isEqual(a,b) {
  // console.log('is equal')
  var x=new Date().valueOf()
  if(typeof a!=typeof b) {
    return false
  }
  if(typeof a=='object' && typeof b=='object') {
    if (Object.keys(a).length!=Object.keys(b).length) return false
  }
  var x=new Date().valueOf()
  var res = require('lodash').isEqual(a,b)
  // console.log(new Date().valueOf()-x,a,b)
  return res
}
function newStore(state) {
    //@ts-ignore
    var Store = state
    var callbacks = {}
    var callbacksNextAvailableKey = 0

    var onBeforeRenders=[]
    Store.onBeforeRender=(callback)=>onBeforeRenders.push(callback)
    var beforeLastRender
    function updateStoreNow() { 
          
        scheduled = false
        if(onBeforeRenders.length>0) {
          if(beforeLastRender) { // skip first time
            onBeforeRenders.forEach(x=>x(beforeLastRender))
          }
          beforeLastRender = cloneDeep(Store)
        }
        for (var i in callbacks) {
            callbacks[i]()
        }
    }


    var scheduled = false
    function Schedule() {
        if (scheduled)
            return
        scheduled = true
        // console.log(new Error().stack)
        setTimeout(updateStoreNow, 0)
    }
    /**
     * @example useRerenderIfChange((store) => [store.scale, store.othervalue])
     * @param callback {(store:Store)=>void}
     */
    Store.useRerenderIfChange = function (callback,name) {
        var _a = react_1.useState(0), _ = _a[0], setMeToRerender = _a[1]
        var callbacksKeyRef = react_1.useRef(callbacksNextAvailableKey++)
        /** The array from the user. Cloned so new changes will not be there */
        var cloned = react_1.useCallback(()=>cloneDeep(callback(Store)))
        var lastValueRef = react_1.useRef(cloned)
        react_1.useEffect(function () {
            // When object mount, add a function to the callbacks, to change if the value changes
            // it will trigged by the "updateStore below"
            callbacks[callbacksKeyRef.current] = function () {
                var currentValue = callback(Store) // The new array of values calculated from the store
                if (!isEqual(currentValue, lastValueRef.current)) {
                    lastValueRef.current = cloneDeep(currentValue) // Update the old array.
                    setMeToRerender(function (prev) { return prev + 1 }) // Rerender the objects
                }
            }
            return function () {
                // When object unmount we don't need this callback any more.
                delete callbacks[callbacksKeyRef.current]
            }
        }, [])
        return lastValueRef.current
    }
    Store.updateStore = function () {
        Schedule()
    }
    return Store
}
exports.newStore = newStore
